import { createClient } from '@supabase/supabase-js'
import { Preferences } from '@capacitor/preferences'
import { Capacitor } from '@capacitor/core'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

const customStorage = {
    getItem: async (key) => {
        if (Capacitor.isNativePlatform()) {
            const { value } = await Preferences.get({ key });
            return value;
        }
        return window.localStorage.getItem(key);
    },
    setItem: async (key, value) => {
        if (Capacitor.isNativePlatform()) {
            await Preferences.set({ key, value });
        } else {
            window.localStorage.setItem(key, value);
        }
    },
    removeItem: async (key) => {
        if (Capacitor.isNativePlatform()) {
            await Preferences.remove({ key });
        } else {
            window.localStorage.removeItem(key);
        }
    }
}

// Explicitly enable session persistence
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
    auth: {
        persistSession: true,
        storage: customStorage,
        autoRefreshToken: true,
        detectSessionInUrl: true
    }
})
